module.exports = __webpack_public_path__ + "img/6.cd11e619.jpg";